<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="ch01">The Dawn of a New Day</h2>
<p class="noindent">I believe that I am given a second chance every day.</p>
<p class="indent">Every morning, I wake up and think that I can do it better today, do it right, whether it’s my job or the people I touch, or don’t touch—or maybe it’s exercise, or what I eat or drink, a kindness, a new interest, or how I relate to my children, or something I learn about myself.</p>
<p class="indent">Each day is a new beginning. Trite? Maybe.</p>
<p class="indentb">But it works for me.</p>
<p class="noindent">—<span class="small">ELLEN</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch01.vue?63924cd9